<template>
    <div>
        <div class="row">
            <div class="col-12">
                <div class="card-body p-0 form-inline">
                    <!-- display the already added photos -->
                    <template v-if="showModifyItemPhotos">
                        <div v-for="(x, i) in images" :key="i" class="mx-1 preview-box">
                            <template v-if="images.length > 0">
                                <img @click="mainPhoto(i)" :src="x.src" class="rounded preview-img" />
                                <small v-if="x.main" class="preview-default text-center">
                                    <p class="my-0 text-light font-weight-bold">main</p>
                                </small>
                                <i v-if="images.length !== 1" @click="removePhoto(i)" class="fas fa-trash-alt p-1 preview-trash rounded text-danger"></i>
                            </template>
                            <i v-else class="far fa-image fa-5x"></i>
                        </div>
                    </template>
                    <!-- add more photos option -->
                    <i @click="showAddPhotosFxn" class="fas fa-camera fa-3x px-2 text-muted clickable"></i>
                </div>
                <label for="itemPhotosCount" class="mt-2">Total item photos count: {{images.length}}</label>
            </div>
        </div>

        <!-- show add more item photos -->
        <app-add-photos v-if="showAddPhotos" :itemId="itemId"></app-add-photos>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { eventBus } from '@/main'
import { appendImgHostUrl } from '@/store/dry'

import AddPhotos from './AddPhotos.vue'

export default {
    name: "ModifyItemPhotos",
    props: ['photos', 'itemId'],
    data() {
        return {
            images: [],
            deletePhotos: [],
            showAddPhotos: false,
        }
    },
    methods: {
        ...mapActions(['modifyItemObj', 'toggleModifyItemPhotos']),
        extractedItemPhotos(itemPhotos) {
            if(itemPhotos){
                // first wipe out the old contents of the images array to avoid duplicates
                this.images = []
                for(let x=0; x < itemPhotos.length; x++){
                    let path = appendImgHostUrl(itemPhotos[x].thumbPath)
                    let obj = {
						src: path,
						main: itemPhotos[x].main
                    }
					this.images.push(obj)
                }
            }
        },
        removePhoto(photoId) {
            // query to see which photo becomes the next mainPhoto
            if(this.photos[photoId].main === true){
                if(this.photos.length > 1){
                    // if the last photo was clicked then minus 1 then set as main photo
                    if(this.photos.length === (photoId + 1)){ 
                        this.mainPhoto(photoId - 1) 
                    }
                    // else add 1 then set as main photo
                    else { 
                        this.mainPhoto(photoId + 1) 
                    }
                }
            }
            // store the to-be-deleted object inside the this.deletePhotos-array
            this.deletePhotos.push(this.photos[photoId])

            // remove photo from both variable arrays
            this.photos.splice(photoId, 1)

            // re-run the extractedItemPhotos to display the new this.photos values
            this.extractedItemPhotos(this.thePhotosArr)

            // save the updated photos array back to the modifyItemObj vuex
            let updateItemPhotosObj = {
                photos: this.photos,
                deletePhotos: this.deletePhotos
            }
            this.modifyItemObj(updateItemPhotosObj).then(() => {}).catch((e) => {})
        },
        mainPhoto(photoId) {
            if(this.photos.length > 0){
                // set as main photo in images
                for(let x=0; x < this.photos.length; x++){
                    this.photos[x].main = false
                }
                this.photos[photoId].main = true

                // re-run the extractedItemPhotos to display the new this.photos values
                this.extractedItemPhotos(this.thePhotosArr)

                // save the updated photos array back to the modifyItemObj vuex
                let updateItemPhotosObj = {
                    photos: this.photos
                }
                this.modifyItemObj(updateItemPhotosObj).then(() => {}).catch((e) => {})
            }
        },
        showAddPhotosFxn() {
            /* close this whole component display so that when its re-opened by 
            // the destroy() in AddPhotos page it re-renders all the images correctly */
            this.toggleModifyItemPhotos(false)
            this.showAddPhotos = true
        }
    },
    computed: {
        ...mapGetters(['showModifyItemPhotos']),
        thePhotosArr() {
            // this auto-refreshes itself to accomodate the newly added photos
            if(this.photos){
                return this.photos
            }
            return false
        }
    },
    components: {
        appAddPhotos: AddPhotos,
    },
    watch: {
        photos() {
            // now re-run the extractedItemPhotos to also display the newly added photos
            if(this.thePhotosArr){
                this.extractedItemPhotos(this.thePhotosArr)
            }
        },
    },
	created() {
        eventBus.$on('hideGhostMode', (value) => {
            this.showAddPhotos = value
        })
        if(this.thePhotosArr){
            this.extractedItemPhotos(this.thePhotosArr)
        }
	}
}
</script>